import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d6a3e2a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: $setup.type === 2 ? $setup.tvicBg : $setup.type === 1 ? $setup.bvicBg : $setup.vicBg,
      class: "header-bg"
    }, null, 8, _hoisted_2),
    _createVNode(_component_SvgIcon, {
      class: "header-logo",
      "icon-name": $setup.headerLogo
    }, null, 8, ["icon-name"])
  ]))
}